module.exports = __webpack_public_path__ + "img/cloudview_music-menu.418a45c5.jpg";